(function () {
  function sdIsProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function sdRealCartDrawerIsOpen() {
    var drawer = document.querySelector(
      '#MinimogCartDrawer, .m-cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer]'
    );

    if (!drawer) return false;

    var className = drawer.className ? String(drawer.className) : '';
    var ariaHidden = drawer.getAttribute('aria-hidden');

    return (
      drawer.hasAttribute('open') ||
      className.indexOf('open') !== -1 ||
      className.indexOf('active') !== -1 ||
      className.indexOf('is-open') !== -1 ||
      className.indexOf('m-cart-drawer--open') !== -1 ||
      ariaHidden === 'false'
    );
  }

  function sdForceUnlockProductScroll() {
    if (!sdIsProductPage()) return;

    /*
      Only keep scroll locked if cart drawer is truly open.
      If drawer is closed or user returned from cart/back navigation,
      force unlock.
    */
    if (sdRealCartDrawerIsOpen()) return;

    document.documentElement.style.overflow = '';
    document.documentElement.style.position = '';
    document.documentElement.style.height = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.height = '';
    document.body.style.top = '';

    document.documentElement.classList.remove(
      'm:overflow-hidden',
      'overflow-hidden',
      'no-scroll',
      'scroll-lock',
      'scroll-locked',
      'is-locked',
      'drawer-open',
      'cart-drawer-open',
      'modal-open'
    );

    document.body.classList.remove(
      'm:overflow-hidden',
      'overflow-hidden',
      'no-scroll',
      'scroll-lock',
      'scroll-locked',
      'is-locked',
      'drawer-open',
      'cart-drawer-open',
      'modal-open'
    );
  }

  function sdDelayedUnlock() {
    setTimeout(sdForceUnlockProductScroll, 50);
    setTimeout(sdForceUnlockProductScroll, 200);
    setTimeout(sdForceUnlockProductScroll, 600);
    setTimeout(sdForceUnlockProductScroll, 1200);
  }

  window.addEventListener('pageshow', sdDelayedUnlock);
  window.addEventListener('popstate', sdDelayedUnlock);
  window.addEventListener('focus', sdDelayedUnlock);
  window.addEventListener('visibilitychange', sdDelayedUnlock);

  document.addEventListener('DOMContentLoaded', sdDelayedUnlock);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target) return;

    if (
      target.closest('[href*="/products/"]') ||
      target.closest('[href*="/cart"]') ||
      target.closest('[data-cart-remove]') ||
      target.closest('.m-cart-item__remove') ||
      target.closest('.cart-remove') ||
      target.closest('[aria-label*="Remove"]') ||
      target.closest('[aria-label*="Close"]') ||
      target.closest('.m-cart-drawer__close') ||
      target.closest('.cart-drawer__close')
    ) {
      sdDelayedUnlock();
    }
  });
})();
